import SingleRow from "./singleRow";
import React from "react";

export default function Bids({bids, auctionData}){
    return(
        <>
            {bids.map((bid,index)=>(
                <SingleRow bid={bid} key={index} auctionData={auctionData}
                />
            ))}
        </>
    )
}